export default __webpack_public_path__ + "static/media/iaapa-logo.5eb5b3b7.svg";